<template>
  <div class="framework-page">
    <navigation-bar />
    <slot />
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="brand-footer">Foodsoft</p>
            <p class="copy-footer">{{ $t('copyright', {age: currentAge}) }}</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
    import NavigationBar from './NavigationBar';
    import moment from "moment";

    export default {
        components: { NavigationBar },
        i18nOptions: {namespaces: ['router', 'footer']},
        name: "AppFramework",
        data: () => ({
          currentAge: moment().format('Y')
        })
    }
</script>

<style>
    .framework-page {
        min-height: 100vh;
    }

    .framework-slot {
        /*padding-top: 30px;*/
    }

    .framework-page > header {
        display: table;
    }

    .framework-page > header > .breadcrumbs {
      margin: 30px 0 5px;
    }

    .framework-page > header > h1 {
        font-size: 2rem;
        text-transform: uppercase;
        margin-top: 30px;
        margin-bottom: 20px;
    }

    .framework-page > header > .breadcrumbs + h1 {
      margin-top: 0;
    }

    .framework-slot > .toolbar {
        margin-bottom: 10px;
    }

    .framework-slot > .toolbar > .col {
        margin-bottom: 10px;
    }

    .framework-page > footer {
        margin-top: 60px;
    }

    .framework-page > footer .brand-footer {
        font-family: Poppins, sans-serif;
        font-weight: 500;
        font-size: 1.57rem;
        line-height: 1em;
        margin-bottom: 0;
        text-align: center;
        color: #999;
    }

    .framework-page > footer .copy-footer {
        text-align: center;
        color: #999;
    }
</style>
